var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0973 11.903C10.8268 10.632 9.96157 9.01282 9.61092 7.25019C9.26027 5.48756 9.43996 3.66054 10.1273 2C8.16761 2.38579 6.36755 3.34738 4.95733 4.76177C1.01423 8.705 1.01423 15.099 4.95733 19.0422C8.90144 22.9864 15.2942 22.9854 19.2383 19.0422C20.6523 17.6321 21.6138 15.8324 22 13.8731C20.3395 14.5603 18.5126 14.7399 16.75 14.3893C14.9875 14.0386 13.3684 13.1734 12.0973 11.903Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.698930e5b4bbb71e212dc0565e65936f.svg";
export { ForwardRef as ReactComponent };